import { BaseApiService } from "Apis/Service/BaseApiService";
import { IAreaController } from "Interfaces/Controllers/IAreaController";
import { inject, injectable } from "inversify";
import { Area } from "Models/Areas/Area";
import Types from "ServiceProvider/Types";
import { EnvConfigUtils } from "Utils/EnvConfigUtils";
import request from "../BaseRequest";

@injectable()
export class AreaController extends BaseApiService implements IAreaController {

    constructor(@inject(Types.IEnvConfigUtils) envConfigUtils: EnvConfigUtils) {
        super(envConfigUtils, "company");
    }

    public async getAreasForCompanyAsync(): Promise<Area[]> {
        this.init();

        const response = await request
            .get(`${this.endpoint}/areas`)
            .set(this.headers);

        return response.body as Area[];
    }
}


// WEBPACK FOOTER //
// ./src/Apis/Controllers/AreaController.ts